export function isDeepEqual(
  a: unknown,
  b: unknown,
  seenA = new WeakMap<object, boolean>(),
  seenB = new WeakMap<object, boolean>()
): boolean {
  // Primitive equality and same reference
  if (a === b) return true

  // Handle null explicitly
  if (a === null || b === null) return a === b

  // Different types
  if (typeof a !== typeof b) return false
  if (Array.isArray(a) !== Array.isArray(b)) return false

  // Primitives that aren't equal
  if (typeof a !== 'object') return false

  // Check for circular references
  if (seenA.has(a as object) || seenB.has(b as object)) {
    return seenA.has(a as object) && seenB.has(b as object)
  }

  // Mark objects as seen
  seenA.set(a as object, true)
  seenB.set(b as object, true)

  // Handle dates
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime()
  }

  // Handle arrays
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false
    return a.every((item, index) =>
      isDeepEqual(item, b[index], seenA, seenB)
    )
  }

  // Handle objects
  if (a instanceof Object && b instanceof Object) {
    const keysA = Object.keys(a)
    const keysB = Object.keys(b)

    if (keysA.length !== keysB.length) return false

    return keysA.every(
      (key) =>
        keysB.includes(key) &&
        isDeepEqual(
          (a as Record<string, unknown>)[key],
          (b as Record<string, unknown>)[key],
          seenA,
          seenB
        )
    )
  }

  return false
}
